// Module
var code = "<nova-pie-chart ng-if=\"vm.mxNovaLoader.isLoaded\" showlegend=\"{{vm.showLegend}}\" showtotal=\"{{vm.showTotal}}\" cutout=\"{{:: vm.isDonut ? '75%' : '0'}}\" data=\"[]\"></nova-pie-chart>\r\n";
// Exports
export default code;